import React from 'react';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-navy px-6 py-24 text-white lg:px-8" data-id="element-84">
      <div className="mx-auto max-w-4xl text-center" data-id="element-85">
        <h2 className="text-4xl font-extrabold leading-tight md:text-5xl" data-id="element-86">
          Dejá de bajar precios para cerrar clientes.
        </h2>
        <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-white/75 md:text-xl" data-id="element-87">
          Ordená tu trabajo. Decí mejor lo que hacés. Cobrá sin dar
          explicaciones de más.
        </p>

        <button onClick={scrollToPricing} className="mt-10 rounded-xl bg-brand-accent px-8 py-5 text-lg font-extrabold text-white shadow-soft-lg transition hover:-translate-y-0.5 hover:bg-blue-600" data-id="element-88">
          Quiero acceder ahora
        </button>

        <div className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-white/75" data-id="element-89">
          <span className="flex items-center gap-2" data-id="element-90">
            <Lock className="h-4 w-4 text-brand-gold" data-id="element-91" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-92">
            <Zap className="h-4 w-4 text-brand-gold" data-id="element-93" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-94">
            <ShieldCheck className="h-4 w-4 text-brand-gold" data-id="element-95" /> Garantía de 21
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-96">
            <CreditCard className="h-4 w-4 text-brand-gold" data-id="element-97" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}